module.exports = __webpack_public_path__ + "img/big_1_25.e3258644.png";